import { LiqPrefLedgerItem } from 'api';
import { LPL_EFFECTIVE_DATE_ALIAS } from 'common/constants/cap-table';
import { GridType } from 'common/types/scalarSpreadsheet';
import { parseDatabaseValue } from 'utilities';
import { LiqPrefLedgerReverseParser } from './liquidation-preference.types';
import { extractColumnLetterSet } from '../../../utilities/variablePropertiesUtils';

type LiqPrefLedgerItemKeys = keyof Pick<
  LiqPrefLedgerItem,
  | 'dividend_rate'
  | 'compounding_period'
  | 'has_compounding'
  | 'liquidation_preference'
  | 'has_dividends'
  | 'name'
  | 'effective_date'
  | 'multiple_of'
  | 'dividend_yearfrac_basis'
>;

const liqPrefLedgerReverseParser: LiqPrefLedgerReverseParser = params => {
  /**
   * @description Takes cells and converts them into ledger items by iterating over the cells, identifying the relevant cells, and then mapping them to the relevant ledger item
   */
  const { cells, tableData } = params;
  const parseCellsIntoLedgerItems = (): LiqPrefLedgerItem[] => {
    const relevantLedgerKeys: LiqPrefLedgerItemKeys[] = [
      'dividend_rate',
      'compounding_period',
      'effective_date',
      'has_compounding',
      'liquidation_preference',
      'has_dividends',
      'name',
      'multiple_of',
      'dividend_yearfrac_basis',
    ];
    const cellToLedgerMapping = new Map<string, LiqPrefLedgerItem>();

    // this can get refactored big time and more performant
    Object.values(cells).forEach((cell): void => {
      const cellLetter = extractColumnLetterSet(cell.key ?? '');
      if (!cellLetter) {
        console.error(`Cell letter not found when parsing cell key: CellKey: ${cell.key} `);
        return;
      }

      const isRelevantDataCell = relevantLedgerKeys.includes(cell.alias as LiqPrefLedgerItemKeys);
      if (!isRelevantDataCell) {
        return;
      }

      const parsedValue = parseDatabaseValue({
        value: cell.value,
        type: cell.dbType,
        gridType: cell.gridType as GridType,
        format: cell.format,
        allowEmptyValues: true,
      });
      const cellValue =
        parsedValue === '' || (!tableData.isUsingByExitDate && cell.alias === LPL_EFFECTIVE_DATE_ALIAS)
          ? null
          : parsedValue;

      if (cellToLedgerMapping.has(cellLetter)) {
        const currentMapping = cellToLedgerMapping.get(cellLetter);
        cellToLedgerMapping.set(cellLetter, {
          ...currentMapping,
          [cell.alias as string]: cellValue,
        } as LiqPrefLedgerItem);
      } else {
        cellToLedgerMapping.set(cellLetter, {
          [cell.alias as string]: cellValue,
          id: cell.entityId,
        } as LiqPrefLedgerItem);
      }
    });

    return Array.from(cellToLedgerMapping.values());
    // each unique key is a new ledger item
  };

  return parseCellsIntoLedgerItems();
};

export default liqPrefLedgerReverseParser;
